import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=7493897e&scoped=true&"
import script from "./Resource.vue?vue&type=script&lang=js&"
export * from "./Resource.vue?vue&type=script&lang=js&"
import style0 from "./Resource.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Resource.vue?vue&type=style&index=1&id=7493897e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7493897e",
  null
  
)

export default component.exports